module.exports = __webpack_public_path__ + "img/2.1d7d2036.svg";